import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["spotMap", "formFields", "selectInput"]
  static outlets = ["bookings-drop-in-spot-selection-map"]

  async showMap(event) {
    event.preventDefault()
    this.#showMap()
  }

  showList(event) {
    event.preventDefault()
    this.#showList()
  }

  selectSpot({ detail: { spotId } }) {
    console.debug("[SpotSelection] selected", spotId)

    this.selectInputTarget.value = spotId
    this.selectInputTarget.dispatchEvent(new Event('change'));
    this.#showList()

    this.dispatch("selected")
  }

  #hide(element) {
    element.classList.add("hidden")
  }

  #showMap() {
    this.#hide(document.getElementById("site-header"))
    this.#hide(document.getElementById("site-footer"))
    this.#hide(document.getElementById("cookie-consent-banner"))
    this.#hide(this.formFieldsTarget)
    this.bookingsDropInSpotSelectionMapOutlet.selectedSpotIdValue = this.selectInputTarget.value
    this.bookingsDropInSpotSelectionMapOutlet.renderMap()
    this.#show(this.spotMapTarget)
  }

  #showList() {
    this.#hide(this.spotMapTarget)
    this.#show(document.getElementById("site-header"))
    this.#show(document.getElementById("site-footer"))
    this.#show(document.getElementById("cookie-consent-banner"))
    this.#show(this.formFieldsTarget)
  }

  #show(element) {
    element.classList.remove("hidden")
  }
}
